import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { IntakeProvider, useIntake } from '../../contexts/IntakeContext'
import useUserIntakePreferencesFetcher from '../../hooks/useUserIntakePreferencesFetcher'
import { useSnackbar } from '../../hooks'
import { RequestService } from '../../services/RequestService'
import IntakeCaffeineType from '../Intake/IntakeCaffeineType'
import IntakeCaffeineTime from '../Intake/IntakeCaffeineTime'
import { ROUTES } from '../../routes'
import { useTranslation } from "react-i18next"

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  padding: 44px;
`

const IntakeSteps = () => {
  const [currentStep, setCurrentStep] = useState(0)
  const { data } = useUserIntakePreferencesFetcher()
  const {
    caffeineTime,
    selectedCaffeineOptions,
    setCaffeineProducts,
    setCaffeineTime,
  } = useIntake()
  const navigate = useNavigate()
  const { t } = useTranslation('common')

  useEffect(() => {
    if (data) {
      const { caffeineProducts, caffeineTime } = data

      setCaffeineProducts(caffeineProducts)
      if (caffeineTime) setCaffeineTime(caffeineTime)
    }
  }, [data])

  const handleNext = () => {
    setCurrentStep(prevStep => prevStep + 1)
  }

  const handlePrevious = () => {
    setCurrentStep(prevStep => prevStep - 1)
  }

  const { errorSnackbar } = useSnackbar()

  const handleFinish = async ({ caffeineTime }) => {
    const { status, data } = await RequestService.saveUserIntake({
      caffeinePreferences: selectedCaffeineOptions,
      caffeineTime,
    })

    if (status === RequestService.STATUSES.SUCCESS) {
      navigate(ROUTES.USER_DASHBOARD)
    } else {
      errorSnackbar({ text: data?.message })
    }
  }

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <IntakeCaffeineType
            step={t('caffeine.two_steps.one')}
            onNext={handleNext}
            onPrevious={() => navigate(ROUTES.USER_DASHBOARD)}
            onFinish={() => navigate(ROUTES.USER_DASHBOARD)}
          />
        )
      case 1:
        return (
          <IntakeCaffeineTime
            step={t('caffeine.two_steps.two')}
            onNext={() => handleFinish({ caffeineTime })}
            onPrevious={handlePrevious}
          />
        )
      default:
        return null
    }
  }

  return <Container>{renderStep()}</Container>
}

const Intake = () => {
  return (
    <IntakeProvider>
      <IntakeSteps />
    </IntakeProvider>
  )
}

export default Intake
